import React from 'react';
import { Alert, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import CustomModal from '../../../components/custom_modal/CustomModal';
import Multiselect from '../../../components/Clima/Multiselect';
import { schema } from './employeeHalfDaySchema';
import { employeeHalfDayData } from './employeeHalfDaysData';
import { updateEmployeeHalfDays } from '../../../redux/vacations/employees_vacations/actions';

const EmployeeHalfDay = ({show, setShow, employee}) => {
  const { isLoadingEmployeeHalfDays,
          employeeHalfDaysFail } = useSelector(state => state.employeesVacations);
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const onSubmit = (values) => {
    const employeeHalfDays = values.employeeHalfDays.map(day => ({
      id: day.value,
      nombre_dia: day.dayName
    }));
    dispatch(updateEmployeeHalfDays(employee.codigo_empleado, { dias_descanso: employeeHalfDays }));
  }
  
  return (
    <Formik initialValues={{
      employeeHalfDays: employee && employee.employeeHalfDays ? employee.employeeHalfDays : [],
    }}  
      validationSchema={schema} 
      onSubmit={onSubmit}
      enableReinitialize={true}>
     {({
      handleSubmit,
      setFieldValue,
      values,
      touched,
      errors,
    }) => (
      <CustomModal 
        show={show} 
        handleClose={handleClose}
        handleSave={handleSubmit}
        title="Días de descanso"
        size="lg"
        isForm={true}
        isSaving={isLoadingEmployeeHalfDays}>
          {
            employeeHalfDaysFail && 
            <Alert variant="danger" className="mb-2">
              employeeHalfDaysFail && employeeHalfDaysFail.fields_with_errors && (
                <Alert variant="danger" className="my-3">
                  {    
                    Object.entries(employeeHalfDaysFail.fields_with_errors).map(([field, errors], index) => (
                      errors.map((error, idx) => (
                        <p key={`${field}-${idx}`}>{error}</p>
                      ))
                    ))
                  }
                </Alert>
              )
            </Alert>
          }
          <Form.Group>
            <Form.Label>Días de descanso</Form.Label>
            <Multiselect
              options={employeeHalfDayData}
              value={values.employeeHalfDays}
              onChange={(value) => setFieldValue('employeeHalfDays', value)}
              isValid={!errors.employeeHalfDays}
              isSubmit={true} />
            {errors.employeeHalfDays &&
              <Form.Text className="text-danger pl-2">
                {errors.employeeHalfDays}
              </Form.Text>
            }
          </Form.Group>
      </CustomModal>
    )}
    </Formik>
  )
}

export default EmployeeHalfDay;